// Module
var code = `<div class="h-9 w-9 flex items-center"> <div class="h-8 w-8 border-r-transparent border-harvustorange animate-spin inline-block border-4 rounded-full" role="status"></div> </div> `;
// Exports
export default code;